import { motion } from "framer-motion";

const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <p className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.35em] text-gold/90" data-testid="section-label">
    {children}
  </p>
);

export default Reveal;
